import { Event } from '@domain/event';
import moment from 'moment-timezone';

export const isEventInThePast = (event?: Event): boolean => {
  if (!event) return false;

  // Get current time in the event's timezone
  const nowInEventTimezone = moment().tz(event.club.city.timezone).unix();

  return event.endingTime < nowInEventTimezone;
};
